import React, { useEffect, useState } from 'react';
import { useUser } from '../../auth/UseUser';
import { getKategorijeVisible } from '../../server/server-kategorije-tree';
import { TypeOfEtity } from '../../model/enum/typeOfEntity';
import { ReactComponent as PuskicaLogoSarena } from '../../assets/svg/PuskicaLogoSarena.svg';
import { handleSelectLink } from '../../utils/utility';
import { useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import { MarkDownView } from '../common/MarkDownView';
import AdSlot from '../common/AdSlot';

function ObrazovanjeHome() {
    const [loading, setLoading] = useState(true);
    const { tipEtiteta, setTipEtiteta, returnedList, setReturnedList, setNavLista } = useUser();
    const [mainList, setMainList] = useState<any[]>([]);
    const navigate = useNavigate();
    useEffect(() => {
        loadKategorijeVisible();
    }, []);

    const loadKategorijeVisible = async () => {
        const resp = await getKategorijeVisible();
        if (resp.status === 200) {
            setTipEtiteta(TypeOfEtity.Kategorija);
            setReturnedList(resp.data);
            setMainList(resp.data);
            setNavLista([]);
            setLoading(false);
        } else {
            setLoading(false);
        }
    };

    return (
        <div className="obrazovanje-container no-scroll">
            <div className=" obrazovanje-outer-frame-mobile lg:obrazovanje-outer-frame-web">
                <div className="w-full min-h-full  bg-blueMedium flex flex-col p-4 xs:p-[30px] rounded-[10px]">
                    {!loading && (
                        <>
                            <p className=" text-obrazovanje-title">
                                Ljudsko interesovanje i znanje obuhvataju širok spektar kategorija koje se mogu podeliti na različite oblasti i tematske grupe.
                                Ovde su osnovne kategorije ljudskog interesovanja i znanja
                            </p>
                            <div className="mt-6 flex flex-col gap-3">
                                {mainList.map((item: any, index: number) => {
                                    return <ObrazovanjeItem key={index} item={item} />;
                                })}
                            </div>
                            <AdSlot placement="lista" />
                        </>
                    )}
                    {loading && (
                        <div className="w-full flex-1 flex items-center justify-center">
                            <Oval />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ObrazovanjeHome;

export const ObrazovanjeItem = ({ item }: any) => {
    const navigate = useNavigate();
    return (
        <>
            {/* Desktop version */}
            <p className="text-obrazovanje-primary hidden lg:flex items-center flex-wrap gap-1 ">
                <span
                    className="text-gold flex items-center whitespace-nowrap border-b border-blueSuperLight hover:border-gold cursor-pointer transition-all duration-200"
                    onClick={() => handleSelectLink(item, navigate)}
                    title={`Otvori oblast "${item.naziv}".`}
                >
                    <PuskicaLogoSarena width={40} height={40} className="mr-1" />
                    {item.naziv}:
                </span>
                <MarkDownView source={item?.opis} nazivKlase="lekcija-opis" style={{ color: 'white', textAlign: 'left', backgroundColor: 'transparent' }} />
            </p>
            {/* Mobile version */}
            <button
                className="flex lg:hidden flex-row items-center gap-2 bg-blueDark  rounded-[10px] py-[6px] px-2"
                onClick={() => handleSelectLink(item, navigate)}
            >
                <PuskicaLogoSarena width={45} height={45} />
                <p className="text-obrazovanje-title flex-1 text-left">{item.naziv} </p>
            </button>
        </>
    );
};
